<template>
  <v-data-table
    :loading="loading"
    :headers="headers"
    :items="itemsByDomain"
    :search="search"
  >
    <template v-slot:item.actions="{ item }">
      <div class="my-3">
        <v-btn
          small
          class="mt-3"
          :id="`permissions-table-edit-btn-${item.id}`"
          v-if-has-permission:hide="editPermission"
          @click="() => $emit('edit', item)"
        >
          Edit Permission
        </v-btn>
      </div>
      <div class="my-3">
        <v-btn
          small
          color="error"
          :id="`permissions-table-delete-btn-${item.id}`"
          v-if-has-permission:hide="deletePermission"
          @click="() => $emit('delete', item)"
        >
          Delete Permission
        </v-btn>
      </div>
    </template>
  </v-data-table>
</template>

<script>
/* eslint no-underscore-dangle: ["error", { "allow": ["_id"] }] */

export default {
  name: 'PermissionsTable',
  props: {
    search: String,
  },
  data: () => ({
    items: [],
    headers: [
      { text: 'Permission Name', value: 'name' },
      { text: 'Desciption', value: 'description' },
      { text: 'Domain', value: 'domain_name' },
      {
        text: 'Actions',
        value: 'actions',
        width: 300,
      },
    ],
    loading: false,
  }),
  computed: {
    deletePermission: vm => vm.$permissions.DELETE_PERMISSIONS,
    editPermission: vm => vm.$permissions.EDIT_PERMISSIONS,
    roleDomains: vm => vm.$store.getters.role?.domains,
    allowedDomains() {
      return (this.roleDomains || []).map(d => d._id);
    },
    itemsByDomain() {
      return this.items.filter(i => this.allowedDomains.includes(i.domain));
    },
  },
  methods: {
    fetch() {
      this.loading = true;
      this.$requests
        .get('/v1/permissions')
        .then(response => {
          this.items = response.data;
        })
        .catch(() => {
          this.$toast.error('Could not resolve permissions...', { timeout: 3000 });
        })
        .then(() => {
          this.loading = false;
        });
    },
  },
  mounted() {
    this.fetch();
  },
};
</script>
